import type { PatientRequest } from './request-services';

// https://gitlab.com/memr/core-api/-/blob/develop/src/modules/patients/enums/gender-name.ts?ref_type=heads
export enum Gender {
  MALE = 'male',
  FEMALE = 'female',
  OTHER = 'na',
  PREFER_NOT_TO_SAY = 'other',
}

export type ExistingPatient = {
  id: string;
  key?: string;
  patientReferenceId?: string;
  firstName: string;
  lastName: string;
  middleName?: string;
  dateOfBirth: string;
  genderName: string;
  contact: {
    phoneNumber: string;
    emailAddress?: string;
  };
  address: {
    address1?: string;
    address2?: string;
    city?: string;
    state?: string;
    postalCode: string;
  };
  organizationId: string;
  organizationProfile: {
    id: string;
    displayName: string;
    avatarType: string;
  };
  organizationStatus?: Record<string, number>;
  requests?: PatientRequest[];
  status?: string;
  createdAt?: string;
  updatedAt?: string;
};

export type PatientStatus =
  | 'OPEN'
  | 'PROCESSING'
  | 'ACTION REQUIRED'
  | 'COMPLETED'
  | 'CANCELLED'
  | 'CLOSED'
  | 'FS_PENDING'
  | 'FS_PROCESSING'
  | 'FS_CLOSED'
  | 'FS_COMPLETE'
  | 'RU_OPEN'
  | 'RU_PROCESSING'
  | 'RU_COMPLETED';
